import {
  TERMS_AND_CONDITIONS_EXTERNAL_LINK_ES,
  LEGAL_PRIVACY_COOKIES_LINK_ES,
  LEGAL_DATA_PROTECTION_EXTERNAL_LINK_ES,
  LEGAL_IMPRINT_EXTERNAL_LINK_ES,
  LEGAL_ENVIRONMENTAL_PROVISION_EXTERNAL_LINK,
  LEGAL_DATA_PROTECTION_DE,
  LEGAL_IMPRINT_EXTERNAL_LINK,
  LEGAL_TERMS_AND_CONDITIONS_LINK_DE,
  LEGAL_COOKIES_EXTERNAL_LINK,
  LEGAL_DISPOSAL_AND_ENV_EXTERNAL_LINK,
  LEGAL_PRIVACY_EXTERNAL_LINK_IT,
  LEGAL_COOKIES_EXTERNAL_LINK_IT,
  TERMS_AND_CONDITIONS_EXTERNAL_LINK_IT,
  LEGAL_PRIVACY_POLICY_LINK_PT,
  LEGAL_IMPRINT_EXTERNAL_LINK_PT,
  LEGAL_COS_EXTERNAL_LINK_PT,
  LEGAL_REGISTRATION_PRIVACY_POLICY_LINK_PT,
  LEGAL_PRIVACY_COOKIES_LINK_PT,
  LEGAL_PRIVACY_POLICY_LINK_NL,
  LEGAL_IMPRINT_EXTERNAL_LINK_NL,
  LEGAL_TERMS_CONDITIONS_LINK_NL,
  LEGAL_JURIDISCH_LINK_NL,
  LEGAL_PRIVACY_COOKIES_LINK_NL,
  LEGAL_COOKIES_FR,
  LEGAL_CGV_LINK_FR,
  LEGAL_DONNEES_PERSONNEL_FR,
  LEGAL_MENTIONS_FR,
} from '~shared/constants/links.constants';
import { GaTrackingEventLabel } from '~shared/modules/ga-tracking/constants';

const legalImprintRoute = 'PAGES.LEGAL.IMPRINT.ROUTE';
const termsAndConditionsRoute = 'PAGES.LEGAL.TERMS_AND_CONDITIONS.ROUTE';
const legalDisposalAndEnvRoute = 'PAGES.LEGAL.DISPOSAL_AND_ENV.ROUTE';
const legalDataProtectionRoute = 'PAGES.LEGAL.DATA_PROTECTION.ROUTE';
const legalCookiesRoute = 'PAGES.LEGAL.COOKIES.ROUTE';
const legalEnvironmentProvisionalRoute = 'PAGES.LEGAL.ENVIRONMENTAL_PROVISION.ROUTE';
const accessibilityLink = 'PAGES.LEGAL.ACCESSIBILITY.LINK';
const accessibilityRoute = 'PAGES.LEGAL.ACCESSIBILITY.ROUTE';

const LEGAL_PRIVACY_POLICY_TRANSLATION_KEY = 'PAGES.LEGAL.PRIVACY_POLICY.ROUTE';
const LEGAL_CONDITION_SALES_TRANSLATION_KEY = 'PAGES.LEGAL.CONDITION_OF_SALE';

export const GLOBAL_FOOTER_LINKS = {
  de: [
    {
      link: LEGAL_IMPRINT_EXTERNAL_LINK,
      title: legalImprintRoute,
      external: true,
      trackingLabel: GaTrackingEventLabel.GlobalFooterLinkImprint,
    },
    {
      link: LEGAL_TERMS_AND_CONDITIONS_LINK_DE,
      title: 'PAGES.LEGAL.TERMS_AND_CONDITIONS.NEW.ROUTE',
      external: true,
      trackingLabel: GaTrackingEventLabel.GlobalFooterLinkTermsOfUseAndPurchase,
      hideOnSubsidiary: true,
    },
    {
      link: LEGAL_DATA_PROTECTION_DE,
      title: 'PAGES.LEGAL.PRIVACY_POLICY.NEW.ROUTE',
      external: true,
      trackingLabel: GaTrackingEventLabel.GlobalFooterLinkPrivacyPolicy,
    },
    {
      link: LEGAL_COOKIES_EXTERNAL_LINK,
      title: legalCookiesRoute,
      external: true,
      trackingLabel: GaTrackingEventLabel.GlobalFooterLinkCookies,
    },
    {
      link: LEGAL_DISPOSAL_AND_ENV_EXTERNAL_LINK,
      title: legalDisposalAndEnvRoute,
      external: true,
      trackingLabel: GaTrackingEventLabel.GlobalFooterLinkDisposalAndEnvironmentalRegulations,
    },
  ],
  es: [
    {
      link: LEGAL_DATA_PROTECTION_EXTERNAL_LINK_ES,
      title: legalDataProtectionRoute,
      external: true,
      trackingLabel: GaTrackingEventLabel.GlobalFooterLinkPrivacyPolicy,
    },
    {
      link: LEGAL_IMPRINT_EXTERNAL_LINK_ES,
      title: legalImprintRoute,
      external: true,
      trackingLabel: GaTrackingEventLabel.GlobalFooterLinkImprint,
    },
    {
      link: LEGAL_PRIVACY_COOKIES_LINK_ES,
      title: legalCookiesRoute,
      external: true,
      trackingLabel: GaTrackingEventLabel.GlobalFooterLinkCookies,
    },
    {
      link: TERMS_AND_CONDITIONS_EXTERNAL_LINK_ES,
      title: termsAndConditionsRoute,
      external: true,
      trackingLabel: GaTrackingEventLabel.GlobalFooterLinkTermsOfUseAndPurchase,
    },
    {
      link: LEGAL_ENVIRONMENTAL_PROVISION_EXTERNAL_LINK,
      title: legalEnvironmentProvisionalRoute,
      external: true,
      trackingLabel: GaTrackingEventLabel.GlobalFooterLinkDisposalAndEnvironmentalRegulations,
    },
  ],
  it: [
    {
      link: LEGAL_PRIVACY_EXTERNAL_LINK_IT,
      title: 'Privacy',
      external: true,
      trackingLabel: GaTrackingEventLabel.GlobalFooterLinkPrivacyPolicy,
    },
    {
      link: LEGAL_COOKIES_EXTERNAL_LINK_IT,
      title: 'Cookies',
      external: true,
      trackingLabel: GaTrackingEventLabel.GlobalFooterLinkCookies,
    },
    {
      link: TERMS_AND_CONDITIONS_EXTERNAL_LINK_IT,
      title: 'Termini e condizioni',
      external: true,
      trackingLabel: GaTrackingEventLabel.GlobalFooterLinkTermsOfUseAndPurchase,
    },
  ],
  pt: [
    {
      link: LEGAL_PRIVACY_POLICY_LINK_PT,
      title: LEGAL_PRIVACY_POLICY_TRANSLATION_KEY,
      external: true,
      trackingLabel: GaTrackingEventLabel.GlobalFooterLinkPrivacyPolicy,
    },
    {
      link: LEGAL_IMPRINT_EXTERNAL_LINK_PT,
      title: legalImprintRoute,
      external: true,
      trackingLabel: GaTrackingEventLabel.GlobalFooterLinkImprint,
    },
    {
      link: LEGAL_COS_EXTERNAL_LINK_PT,
      title: LEGAL_CONDITION_SALES_TRANSLATION_KEY,
      external: true,
      trackingLabel: GaTrackingEventLabel.conditionOfSale,
    },

    // {
    //   link: LEGAL_REGISTRATION_PRIVACY_POLICY_LINK_PT,
    //   title: 'PAGES.LEGAL.REGISTRATION_PRIVACY_POLICY',
    //   external: true,
    //   trackingLabel: GaTrackingEventLabel.registrationPrivacyPolicy
    // },
    {
      link: LEGAL_PRIVACY_COOKIES_LINK_PT,
      title: legalCookiesRoute,
      external: true,
      trackingLabel: GaTrackingEventLabel.GlobalFooterLinkCookies,
    },
  ],
  nl: [
    {
      link: LEGAL_PRIVACY_POLICY_LINK_NL,
      title: LEGAL_PRIVACY_POLICY_TRANSLATION_KEY,
      external: true,
      trackingLabel: GaTrackingEventLabel.GlobalFooterLinkPrivacyPolicy,
    },
    {
      link: LEGAL_IMPRINT_EXTERNAL_LINK_NL,
      title: legalImprintRoute,
      external: true,
      trackingLabel: GaTrackingEventLabel.GlobalFooterLinkImprint,
    },
    {
      link: LEGAL_TERMS_CONDITIONS_LINK_NL,
      title: LEGAL_CONDITION_SALES_TRANSLATION_KEY,
      external: true,
      trackingLabel: GaTrackingEventLabel.conditionOfSale,
    },
    {
      link: LEGAL_JURIDISCH_LINK_NL,
      title: 'PAGES.LEGAL.REGISTRATION_PRIVACY_POLICY',
      external: true,
      trackingLabel: GaTrackingEventLabel.registrationPrivacyPolicy,
    },
    {
      link: LEGAL_PRIVACY_COOKIES_LINK_NL,
      title: legalCookiesRoute,
      external: true,
      trackingLabel: GaTrackingEventLabel.GlobalFooterLinkCookies,
    },
  ],
  fr: [
    {
      link: LEGAL_CGV_LINK_FR,
      title: LEGAL_CONDITION_SALES_TRANSLATION_KEY,
      external: true,
      trackingLabel: GaTrackingEventLabel.conditionOfSale,
    },
    {
      link: LEGAL_COOKIES_FR,
      title: legalCookiesRoute,
      external: true,
      trackingLabel: GaTrackingEventLabel.GlobalFooterLinkCookies,
    },
    {
      link: LEGAL_DONNEES_PERSONNEL_FR,
      title: LEGAL_PRIVACY_POLICY_TRANSLATION_KEY,
      external: true,
      trackingLabel: GaTrackingEventLabel.GlobalFooterLinkPrivacyPolicy,
    },
    {
      link: LEGAL_MENTIONS_FR,
      title: legalImprintRoute,
      external: true,
      trackingLabel: GaTrackingEventLabel.GlobalFooterLinkImprint,
    },
  ],
};

export const ACCESSIBILITY_FOOTER_LINK = {
  link: accessibilityLink,
  title: accessibilityRoute,
  external: true,
  trackingLabel: GaTrackingEventLabel.GlobalFooterLinkAccessibility,
};
